var map = {
	"./DataType.svg": 10334,
	"./Description.svg": 59988,
	"./ErrorPlaceholder.svg": 19147,
	"./GenAI.svg": 60106,
	"./GenAIColored.svg": 30248,
	"./GraphIllustration.svg": 82264,
	"./MongoDBCollection.svg": 85728,
	"./NewTabFromSummary.svg": 34491,
	"./ReportingDBCollection.svg": 88134,
	"./SampleData.svg": 76288,
	"./Teams.svg": 23072,
	"./ToyotaLogo.svg": 23253,
	"./ToyotaLogoHorizontal.svg": 15541,
	"./VehicleCategory.svg": 52786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92282;